import { Badge } from '@/common/components/Badge/Badge';
import { ICard } from '@/common/integrations/menhir/employee/card/card.types';
import { t } from 'i18next';
import { styles } from './CoverflexCardDetailsHorizontalUtils.styles';

export const getBadge = (card: ICard) => {
  if (
    card.format === 'digital' &&
    card.status === 'active' &&
    !card.isExpiring
  ) {
    return (
      <Badge status={'success'} emphasis="soft" className={styles.badge()}>
        {t('card.badge.digital')}
      </Badge>
    );
  }

  if (card.status === 'active' && card.isExpiring) {
    return (
      <Badge status={'warning'} emphasis="soft" className={styles.badge()}>
        {t('card.badge.expiring')}
      </Badge>
    );
  }

  if (card.status === 'expired') {
    return (
      <Badge status={'error'} className={styles.badge()}>
        {t('card.expired.status')}
      </Badge>
    );
  }

  if (card.status === 'cancelled') {
    return (
      <Badge status={'disabled'} className={styles.badge()}>
        {t('card.status.cancelled')}
      </Badge>
    );
  }

  if (card.status === 'locked') {
    return (
      <Badge status={'info'} className={styles.badge()}>
        {t('card.locked.status')}
      </Badge>
    );
  }
};
